














import { Component, Vue, Prop } from 'vue-property-decorator'
import pages from '@/constants/pages'
import { EFriend } from '@/types/categories/friend'
import { EPresent } from '@/types/categories/present'

@Component({})
export default class GameOver extends Vue {
  @Prop(String) selectedFriend!: EFriend
  @Prop(String) selectedSecretSanta!: EFriend
  @Prop(String) selectedPresent!: EPresent
  @Prop(Boolean) error!: boolean
}
